import { createContext, useContext, useState, type ReactNode } from "react";
import {
  DEV_USERS,
  getActiveDevEmail,
  setActiveDevEmail,
  clearActiveDevEmail,
} from "./devUsers";

interface DevAuthContextValue {
  email: string;
  setEmail: (email: string) => void;
  signOut: () => void;
}

const DevAuthContext = createContext<DevAuthContextValue | null>(null);

export function DevAuthProvider({ children }: { children: ReactNode }) {
  const [email, setEmailState] = useState<string>(() => getActiveDevEmail());

  const setEmail = (newEmail: string) => {
    setActiveDevEmail(newEmail);
    setEmailState(newEmail);
    // Reload pra rebustar o useMe e estado de queries
    window.location.reload();
  };

  const signOut = () => {
    clearActiveDevEmail();
    window.location.reload();
  };

  return (
    <DevAuthContext.Provider value={{ email, setEmail, signOut }}>
      {children}
      <DevUserBadge currentEmail={email} onChange={setEmail} />
    </DevAuthContext.Provider>
  );
}

export function useDevAuth() {
  const ctx = useContext(DevAuthContext);
  if (!ctx) throw new Error("useDevAuth fora de DevAuthProvider");
  return ctx;
}

function DevUserBadge({
  currentEmail,
  onChange,
}: {
  currentEmail: string;
  onChange: (email: string) => void;
}) {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 12,
        right: 12,
        zIndex: 9999,
        background: "#fef3c7",
        border: "1px solid #f59e0b",
        borderRadius: 8,
        padding: "6px 10px",
        fontSize: 11,
        fontFamily: "system-ui, sans-serif",
        boxShadow: "0 2px 8px rgba(0,0,0,.1)",
        display: "flex",
        flexDirection: "column",
        gap: 4,
        maxWidth: 280,
      }}
    >
      <strong style={{ color: "#92400e" }}>SANDBOX (AUTH_MODE=dev)</strong>
      <select
        value={currentEmail}
        onChange={(e) => onChange(e.target.value)}
        style={{
          padding: "3px 6px",
          fontSize: 11,
          border: "1px solid #fbbf24",
          borderRadius: 4,
          background: "white",
          cursor: "pointer",
        }}
      >
        {DEV_USERS.map((u) => (
          <option key={u.email} value={u.email}>
            {u.name} ({u.description})
          </option>
        ))}
      </select>
      <span style={{ color: "#78350f" }}>JWT desabilitado · não usar em prod</span>
    </div>
  );
}
